function OrangeHeartSVG() {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2734 1.11482C11.59 2.01317 10.3942 3.6543 9.93073 5.62114C8.0957 4.8809 6.1188 4.93282 4.46774 5.8139C1.03612 7.64516 -0.148498 12.385 1.82302 16.3958C3.70154 20.2175 7.3 22.8825 12.2244 24.1713C15.8655 25.094 18.9025 24.954 19.0182 24.94L19.384 24.9359L19.6009 24.6291C19.6794 24.5394 21.5956 22.0362 22.9725 18.4356C24.8466 13.5189 24.874 8.91898 22.9955 5.09732C21.0887 1.05191 16.705 -0.716438 13.2734 1.11482Z"
          fill="#FF944D"
        />
      </svg>
    );
}

function TealHeartSVG() {
    return (
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0064 1.11482C13.6898 2.01317 14.8855 3.6543 15.3491 5.62114C17.1841 4.8809 19.161 4.93282 20.812 5.8139C24.2437 7.64516 25.4283 12.385 23.4568 16.3958C21.5782 20.2175 17.9798 22.8825 13.0554 24.1713C9.4143 25.094 6.37731 24.954 6.26159 24.94L5.89583 24.9359L5.67886 24.6291C5.60034 24.5394 3.68414 22.0362 2.3073 18.4356C0.433191 13.5189 0.405784 8.91898 2.2843 5.09732C4.19107 1.05191 8.57475 -0.716438 12.0064 1.11482Z"
          fill="#51D6D5"
        />
      </svg>
    );
}

export {OrangeHeartSVG, TealHeartSVG}